import * as React from 'react';

import type { ParticipationsClient } from '@/api/participations-client';
import { HttpParticipationsClient } from '@/api/participations-client.http';

// =============================================================================
// participations-client-context.tsx — Injection du ParticipationsClient (DI seam).
// =============================================================================
// AUTO-PORTÉ par la route qui compose le registre (suppliers-list-route.tsx), sur le modèle du
// ClientsClientProvider : le provider enveloppe l'écran localement plutôt que de brancher le client
// dans providers.tsx global. Par défaut : l'adaptateur HTTP RÉEL (parité campaign-client-context) ;
// les tests injectent le StubParticipationsClient via le provider.

const defaultParticipationsClient: ParticipationsClient =
  new HttpParticipationsClient();

const ParticipationsClientContext = React.createContext<ParticipationsClient>(
  defaultParticipationsClient,
);

export interface ParticipationsClientProviderProps {
  client?: ParticipationsClient | undefined;
  children: React.ReactNode;
}

export function ParticipationsClientProvider({
  client = defaultParticipationsClient,
  children,
}: ParticipationsClientProviderProps): React.JSX.Element {
  return (
    <ParticipationsClientContext.Provider value={client}>
      {children}
    </ParticipationsClientContext.Provider>
  );
}

export function useParticipationsClient(): ParticipationsClient {
  return React.useContext(ParticipationsClientContext);
}
